(function () {
  'use strict';
  if (window.__dcbOosPanel) return;
  window.__dcbOosPanel = true;
  function parse(sel) {
    try { var n = document.querySelector(sel); return n ? JSON.parse(n.textContent) : null; }
    catch (e) { return null; }
  }
  var variants = parse('script[data-dcb-oos-variants]') || [];
  var optNames = parse('script[data-dcb-oos-optnames]') || [];
  if (!variants.length) return;
  var byId = {};
  variants.forEach(function (v) { byId[String(v.id)] = v; });
  // component SKUs on every selection surface (Jason 2026-09-22): the
  // card line and the popup column line follow the chosen product,
  // color, size and DIN/Yoke so the sold-alone item is always identifiable
  if (!document.getElementById('dcb-sku-css')) {
    var skuCss = document.createElement('style');
    skuCss.id = 'dcb-sku-css';
    skuCss.textContent = '.dcb-optional-sku{font-size:11px;color:#6b7177;line-height:1.3}' +
      '.dcb-cmp-sku{font-size:11px;color:#6b7177;min-height:1.2em;white-space:nowrap;' +
      'overflow:hidden;text-overflow:ellipsis}';
    (document.head || document.documentElement).appendChild(skuCss);
  }
  var dcbMapCache;
  function includesMap() {
    if (dcbMapCache !== undefined) return dcbMapCache;
    dcbMapCache = parse('[data-dcb-includes] script[data-dcb-map]') || null;
    return dcbMapCache;
  }
  function money(c) {
    return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function currentVariant() {
    var input = document.querySelector(
      'form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    return input ? byId[String(input.value)] : null;
  }
  function pickerScope() {
    return document.querySelector('variant-picker') ||
           document.querySelector('.variant-picker') || document;
  }
  function applyOption(val) {
    var scope = pickerScope();
    var done = false;
    scope.querySelectorAll('input[type=radio]').forEach(function (r) {
      if (done || r.value !== val) return;
      if (!r.checked) r.click();
      done = true;
    });
    if (!done) scope.querySelectorAll('select').forEach(function (s) {
      if (done) return;
      for (var i = 0; i < s.options.length; i++) {
        if (s.options[i].value === val) {
          if (s.selectedIndex !== i) {
            s.selectedIndex = i;
            s.dispatchEvent(new Event('change', { bubbles: true }));
          }
          done = true;
          break;
        }
      }
    });
  }
  function applyWalk(dimIdx, val, done) {
    // apply-and-verify: walk the native picker until the option took
    var attempts = 0;
    (function tick() {
      var c = currentVariant();
      if ((c && c.options[dimIdx] === val) || attempts >= 6) {
        if (done) done();
        return;
      }
      attempts += 1;
      applyOption(val);
      window.setTimeout(tick, 300);
    })();
  }
  function hideNativePicker() {
    document.querySelectorAll('variant-picker, .variant-picker').forEach(function (vp) {
      if (vp.style.display !== 'none') vp.style.display = 'none';
    });
  }
  function entryFor(variantId) {
    var im = includesMap();
    return im && im.variants ? im.variants[String(variantId)] : null;
  }
  function dimValues(i) {
    var seen = [], have = {};
    variants.forEach(function (v) {
      if (!have[v.options[i]]) { have[v.options[i]] = true; seen.push(v.options[i]); }
    });
    return seen;
  }
  function variantWith(cur, i, val) {
    return variants.find(function (v) {
      if (v.options[i] !== val) return false;
      for (var k = 0; k < v.options.length; k++) {
        if (k !== i && v.options[k] !== cur.options[k]) return false;
      }
      return true;
    }) || null;
  }
  // dim -> component position map, derived from the includes map: flipping
  // a PRODUCT dim changes a component's title; flipping an attribute dim
  // changes that component's sku/variant only.
  var dimMapCache = null;
  function dimMap() {
    if (dimMapCache) return dimMapCache;
    dimMapCache = { product: {}, attr: {} }; // optIdx -> position
    var im = includesMap();
    if (!im || !im.variants) return dimMapCache;
    for (var a = 0; a < variants.length; a++) {
      for (var b = a + 1; b < variants.length; b++) {
        var va = variants[a], vb = variants[b];
        var diff = -1, multi = false;
        for (var k = 0; k < va.options.length; k++) {
          if (va.options[k] !== vb.options[k]) {
            if (diff !== -1) { multi = true; break; }
            diff = k;
          }
        }
        if (multi || diff === -1) continue;
        if (dimMapCache.product[diff] || dimMapCache.attr[diff]) continue;
        var ea = entryFor(va.id), eb = entryFor(vb.id);
        if (!ea || !eb || !ea.components || !eb.components) continue;
        for (var c = 0; c < ea.components.length; c++) {
          var ca = ea.components[c], cb = eb.components[c];
          if (!ca || !cb) continue;
          if (ca.title && cb.title && ca.title !== cb.title) {
            dimMapCache.product[diff] = ca.position || (c + 1);
            break;
          }
          if (ca.vg && cb.vg && ca.vg !== cb.vg) {
            dimMapCache.attr[diff] = ca.position || (c + 1);
            break;
          }
        }
      }
    }
    return dimMapCache;
  }
  function optionalDimFor(pos) {
    // variant-based Included/Without dim targeting this position, if any
    for (var i = 0; i < optNames.length; i++) {
      var vals = dimValues(i);
      if (vals.length === 2 && vals.indexOf('Included') !== -1 &&
          vals.indexOf('Without') !== -1) {
        var dm = dimMap();
        if (dm.attr[i] === pos || dm.product[i] === pos) return i;
        // fall back: single optional dim, unmatched -> claim by exclusion
        if (dm.attr[i] === undefined && dm.product[i] === undefined) return i;
      }
    }
    return null;
  }
  // ---- options v3 skip state -----------------------------------------
  window.__dcbSkipPos = window.__dcbSkipPos || {};
  function skipListValue() {
    return Object.keys(window.__dcbSkipPos)
      .filter(function (k) { return window.__dcbSkipPos[k]; })
      .sort().join(',');
  }
  function writeSkipProperty() {
    var val = skipListValue();
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      var idInput = f.querySelector('input[name="id"], select[name="id"]');
      if (!idInput || !byId[String(idInput.value)]) return;
      var name = 'properties[_dcb_skip]';
      var input = f.querySelector('input[name="' + name + '"]');
      if (!val) {
        if (input && input.parentNode) input.parentNode.removeChild(input);
        return;
      }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        f.appendChild(input);
      }
      input.value = val;
    });
  }
  // ---- options v3.6 alt color state (Dany 2026-08-18: every ladder
  // choice with color variations gets its own dropdown; the cart property
  // becomes "Choice :: Color" and the transform resolves that variant) --
  window.__dcbAltColor = window.__dcbAltColor || {};
  function altColorFor(c, chosen) {
    if (!chosen || !Array.isArray(chosen.variants) || chosen.variants.length < 2) return null;
    var memo = (window.__dcbAltColor[c.attr] || {})[chosen.label];
    var def = chosen.variants.find(function (v) { return v && v['default']; }) || chosen.variants[0];
    var pick = memo ? chosen.variants.find(function (v) { return v && v.label === memo; }) : null;
    return { list: chosen.variants, chosen: pick || def, def: def,
             isDefault: !pick || pick.label === def.label,
             optLabel: chosen.opt_label || 'Color' };
  }
  function patchAltProperties() {
    // rewrite alt cart-line properties to "Choice :: Color" for
    // non-default colors; leave the includes block's plain labels alone
    var cur = currentVariant();
    var entry = cur ? entryFor(cur.id) : null;
    if (!entry || !entry.components) return;
    entry.components.forEach(function (c) {
      var ai = altInfo(c);
      if (!ai || !ai.chosen) return;
      var wantVal = null;
      if (ai.color && !ai.color.isDefault) {
        wantVal = ai.chosen.label + ' :: ' + ai.color.chosen.label;
      } else {
        var live = document.getElementById('dcb-pick-' + c.attr);
        wantVal = (live && live.selectedIndex > 0) ? live.value : null;
      }
      var name = 'properties[' + c.attr + ']';
      document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
        var idInput = f.querySelector('input[name="id"], select[name="id"]');
        if (!idInput || !byId[String(idInput.value)]) return;
        var input = f.querySelector('input[name="' + name + '"]');
        if (!wantVal) {
          // only remove values WE wrote (contain the color separator)
          if (input && input.parentNode && input.value.indexOf(' :: ') > -1) {
            input.parentNode.removeChild(input);
          }
          return;
        }
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          f.appendChild(input);
        }
        if (input.value !== wantVal) input.value = wantVal;
      });
    });
  }
  function applyAltColorByPos(pos) {
    // push the chosen alt color everywhere: cart property, includes-grid
    // card, gallery + live composite (same event the pickers dispatch)
    var cur = currentVariant();
    var entry = cur ? entryFor(cur.id) : null;
    if (!entry || !entry.components) return;
    entry.components.forEach(function (c) {
      if (!c || c.position !== pos || !isAltComp(c)) return;
      var ai = altInfo(c);
      if (!ai || !ai.chosen) return;
      patchAltProperties();
      var img = (ai.color && ai.color.chosen.image) || ai.chosen.image || null;
      var grid = document.querySelector('[data-dcb-grid]');
      if (grid && img) {
        var idx = entry.components.indexOf(c);
        var card = grid.querySelectorAll('.dcb-card')[idx];
        var gimg = card && card.querySelector('img');
        if (gimg) gimg.src = img;
      }
      var isBase = !!(ai.base && ai.chosen.label === ai.base.label);
      var isDef = isBase && (!ai.color || ai.color.isDefault);
      try {
        window.dispatchEvent(new CustomEvent('dcb:componentchoice', {
          detail: { title: c.title, image: img, label: ai.chosen.label,
                    attr: c.attr, isDefault: isDef }
        }));
      } catch (e) { /* noop */ }
    });
  }
  function isAltComp(c) {
    // options v3.5 slots are recognized by PRICED choices (the map's alt
    // flag itself is not passed through by the block Liquid)
    return !!(c && c.attr && Array.isArray(c.choices) &&
              c.choices.some(function (ch) {
                return ch && typeof ch.price === 'number';
              }));
  }
  function altInfo(c) {
    // options v3.5: cross-product ladder on the picker channel; choices
    // carry their own price (cents from the map), image and title
    if (!isAltComp(c)) return null;
    var live = document.getElementById('dcb-pick-' + c.attr);
    var chosenLabel = live ? live.value : (c.choices[0] && c.choices[0].label);
    var chosen = c.choices.find(function (ch) { return ch && ch.label === chosenLabel; })
      || c.choices[0];
    return { attr: c.attr, choices: c.choices, chosen: chosen,
             base: c.choices[0], color: altColorFor(c, chosen) };
  }
  function adjustedPriceCents(cur) {
    var total = cur.price;
    var entry = entryFor(cur.id);
    if (entry && entry.components) {
      entry.components.forEach(function (c) {
        if (c && c.removable && c.position && window.__dcbSkipPos[c.position]) {
          total -= Math.round((parseFloat(c.alloc || '0') || 0) * 100);
          return;
        }
        var ai = altInfo(c);
        if (ai && ai.chosen && ai.base
            && typeof ai.chosen.price === 'number'
            && typeof ai.base.price === 'number') {
          total += ai.chosen.price - ai.base.price;
        }
      });
    }
    return Math.max(0, total);
  }
  function paintAdjustedPrice(cur) {
    var shown = adjustedPriceCents(cur);
    document.querySelectorAll('.price__current').forEach(function (el) {
      var want = money(shown);
      if (el.textContent.trim() !== want) el.textContent = want;
    });
  }
  function notifySkipChange() {
    try { window.dispatchEvent(new CustomEvent('dcb:skipchange')); } catch (e) { /* noop */ }
  }
  // ---- component cards -----------------------------------------------
  var cardsWrap = null;
  function pickersFor(pos) {
    var entry = entryFor((currentVariant() || {}).id);
    if (!entry || !entry.components) return [];
    var out = [];
    entry.components.forEach(function (c) {
      if (c && c.position === pos && c.attr && !isAltComp(c)
          && Array.isArray(c.choices) && c.choices.length > 1) {
        out.push({ attr: c.attr,
                   label: typeof c.attr_label === 'string' ? c.attr_label : 'Option',
                   choices: c.choices.filter(function (ch) {
                     return ch && typeof ch.label === 'string';
                   }).map(function (ch) {
                     return { label: ch.label,
                              image: typeof ch.image === 'string' ? ch.image : null,
                              sku: typeof ch.sku === 'string' ? ch.sku : '' };
                   }) });
      }
    });
    return out;
  }
  function currentPickerValue(attr) {
    var el = document.getElementById('dcb-pick-' + attr);
    return el ? el.value : null;
  }
  function componentHasChoices(pos) {
    var dm = dimMap();
    for (var i = 0; i < optNames.length; i++) {
      if (dm.product[i] === pos || dm.attr[i] === pos) return true;
    }
    var entry = entryFor((currentVariant() || {}).id);
    if (entry && entry.components && entry.components.some(function (c) {
      return c && c.position === pos && isAltComp(c);
    })) return true;
    return pickersFor(pos).length > 0;
  }
  function renderCards() {
    var cur = currentVariant();
    var entry = cur ? entryFor(cur.id) : null;
    if (!cur || !entry || !entry.components) return;
    hideNativePicker();
    if (!cardsWrap || !cardsWrap.isConnected) {
      cardsWrap = document.createElement('div');
      cardsWrap.className = 'dcb-optional-wrap';
      var vp = document.querySelector('variant-picker') ||
               document.querySelector('.variant-picker');
      if (vp && vp.parentNode) vp.parentNode.insertBefore(cardsWrap, vp.nextSibling);
      else return;
    }
    cardsWrap.innerHTML = '';
    entry.components.forEach(function (c) {
      if (!c || !c.position) return;
      var pos = c.position;
      var optionalDim = optionalDimFor(pos);
      var removable = c.removable === true;
      // sold-out removable (Linh 2026-11-03): the nightly sync stamps
      // oos:true on a removable whose default variant has no stock. It is
      // unchecked and locked here (and the cart transform drops it as a
      // backstop), so the package stays buyable without the item. A slot
      // with alternates keeps the "tap Options" prompt instead.
      var aiEarly = altInfo(c);
      var altPicked = !!(aiEarly && aiEarly.chosen && aiEarly.base
        && aiEarly.chosen.label !== aiEarly.base.label);
      var forcedOff = removable && c.oos === true && optionalDim === null && !altPicked;
      window.__dcbForcedOff = window.__dcbForcedOff || {};
      if (forcedOff && !window.__dcbForcedOff[pos]) {
        window.__dcbForcedOff[pos] = true;
        window.__dcbSkipPos[pos] = true;
        writeSkipProperty();
      } else if (!forcedOff && window.__dcbForcedOff[pos]) {
        // an in-stock alternate was picked for the slot: include it again
        delete window.__dcbForcedOff[pos];
        window.__dcbSkipPos[pos] = false;
        writeSkipProperty();
      }
      var includedNow = optionalDim === null ? !window.__dcbSkipPos[pos]
        : cur.options[optionalDim] === 'Included';
      var card = document.createElement('div');
      card.className = 'dcb-optional-card' + (includedNow ? ' is-on' : '')
        + (forcedOff ? ' is-forced-off' : '');
      if (removable || optionalDim !== null) {
        var box = document.createElement('input');
        box.type = 'checkbox';
        box.checked = includedNow;
        if (forcedOff) {
          box.disabled = true;
          box.title = 'Sold out';
        }
        box.addEventListener('click', function (e) { e.stopPropagation(); });
        box.addEventListener('change', function () {
          if (optionalDim !== null) {
            var target = variantWith(cur, optionalDim,
                                     box.checked ? 'Included' : 'Without');
            if (target) applyOption(target.options[optionalDim]);
          } else {
            window.__dcbSkipPos[pos] = !box.checked;
            writeSkipProperty();
            var c2 = currentVariant();
            if (c2) paintAdjustedPrice(c2);
            notifySkipChange();
            renderCards();
          }
        });
        card.appendChild(box);
      } else {
        var nobox = document.createElement('span');
        nobox.className = 'dcb-optional-nobox';
        card.appendChild(nobox);
      }
      var cardImg = c.image;
      var cardTitle = c.title || ('Item ' + pos);
      var cardValue = null;
      var ai = altInfo(c);
      if (ai && ai.chosen) {
        if (ai.chosen.title) cardTitle = ai.chosen.title;
        if (ai.chosen.image) cardImg = ai.chosen.image;
        if (ai.color && ai.color.chosen.image) cardImg = ai.color.chosen.image;
        if (typeof ai.chosen.price === 'number') cardValue = ai.chosen.price;
      }
      if (!ai && c.attr && Array.isArray(c.choices)) {
        // show the PICKED color, not the default (interactive like the
        // gallery/composite images)
        var liveSel = document.getElementById('dcb-pick-' + c.attr);
        if (liveSel) {
          var chosenCh = c.choices.find(function (ch) {
            return ch && ch.label === liveSel.value && ch.image;
          });
          if (chosenCh) cardImg = chosenCh.image;
        }
      }
      var imgbox = document.createElement('span');
      imgbox.className = 'dcb-optional-imgbox';
      if (cardImg) {
        var img = document.createElement('img');
        img.className = 'dcb-optional-img';
        img.src = cardImg;
        img.alt = c.title || '';
        imgbox.appendChild(img);
      }
      card.appendChild(imgbox);
      var text = document.createElement('span');
      text.className = 'dcb-optional-text';
      var nm = document.createElement('span');
      nm.className = 'dcb-optional-name';
      nm.textContent = cardTitle;
      text.appendChild(nm);
      var cardSku = typeof c.sku === 'string' ? c.sku : '';
      if (ai && ai.chosen) {
        if (ai.chosen.sku) cardSku = ai.chosen.sku;
        if (ai.color && ai.color.chosen && ai.color.chosen.sku) cardSku = ai.color.chosen.sku;
      } else if (c.attr && Array.isArray(c.choices)) {
        var liveSku = document.getElementById('dcb-pick-' + c.attr);
        var pickedCh = liveSku ? c.choices.find(function (ch) {
          return ch && ch.label === liveSku.value && ch.sku;
        }) : null;
        if (pickedCh) cardSku = pickedCh.sku;
      }
      if (cardSku) {
        var skuLine = document.createElement('span');
        skuLine.className = 'dcb-optional-sku';
        skuLine.textContent = 'SKU ' + cardSku;
        text.appendChild(skuLine);
      }
      // every choice lives ON the card as a labeled dropdown (Dany
      // 2026-08-19: "Din/Yoke should be a selection too like bcd size" +
      // cleaner design): size dims, same-price pickers (Regulator Type,
      // colors) and alt-ladder colors all render the same row style.
      function cardRow(labelText, options, value, onChange) {
        var srow = document.createElement('span');
        srow.className = 'dcb-size-row';
        var lab = document.createElement('span');
        lab.className = 'dcb-size-label';
        lab.textContent = labelText;
        srow.appendChild(lab);
        var ssel = document.createElement('select');
        ssel.addEventListener('click', function (e) { e.stopPropagation(); });
        options.forEach(function (o) {
          var op = document.createElement('option');
          op.value = o.value;
          op.textContent = o.text;
          ssel.appendChild(op);
        });
        if (value) ssel.value = value;
        ssel.addEventListener('change', function (e) {
          e.stopPropagation();
          onChange(ssel.value);
        });
        srow.appendChild(ssel);
        text.appendChild(srow);
      }
      var dmc = dimMap();
      for (var di = 0; di < optNames.length; di++) {
        if (dmc.attr[di] !== pos) continue;
        var dvals = dimValues(di);
        if (dvals.length < 2 || dvals.indexOf('Included') !== -1) continue;
        (function (dii, vv) {
          cardRow(optNames[dii], vv.map(function (val) {
            var t = variantWith(cur, dii, val);
            return { value: val,
                     text: val + (t && !t.available ? ' \u2014 sold out' : '') };
          }), cur.options[dii], function (want) {
            var attempts = 0;
            (function tick() {
              var c4 = currentVariant();
              if ((c4 && c4.options[dii] === want) || attempts >= 6) {
                renderCards();
                return;
              }
              attempts += 1;
              applyOption(want);
              window.setTimeout(tick, 300);
            })();
          });
        })(di, dvals);
      }
      // same-price pickers (Regulator Type, Mask/Snorkel Color, ...)
      pickersFor(pos).forEach(function (pk) {
        cardRow(pk.label, pk.choices.map(function (ch) {
          return { value: ch.label, text: ch.label };
        }), currentPickerValue(pk.attr), function (v2) {
          var live = document.getElementById('dcb-pick-' + pk.attr);
          if (live) {
            live.value = v2;
            live.dispatchEvent(new Event('change', { bubbles: true }));
          }
          window.setTimeout(renderCards, 350);
        });
      });
      // alt-ladder color for the CURRENT choice
      if (ai && ai.color) {
        cardRow(ai.color.optLabel, ai.color.list.map(function (v) {
          return { value: v.label, text: v.label };
        }), ai.color.chosen.label, function (v3) {
          (window.__dcbAltColor[c.attr] = window.__dcbAltColor[c.attr] || {})[ai.chosen.label] = v3;
          applyAltColorByPos(pos);
          renderCards();
        });
      }
      // size chart reference: the CURRENT product's own chart page,
      // baked at publish (grounded -- never invented)
      var chartHandle = (ai && ai.chosen && ai.chosen.handle) || c.handle;
      var pInfoC = chartHandle ? productInfo(chartHandle) : null;
      if (pInfoC && pInfoC.size_chart) {
        (function (chart) {
          var lrow = document.createElement('span');
          lrow.className = 'dcb-size-row dcb-size-row--link';
          var spacer = document.createElement('span');
          spacer.className = 'dcb-size-label';
          spacer.innerHTML = '&nbsp;';
          lrow.appendChild(spacer);
          var scl = document.createElement('a');
          scl.href = '#';
          scl.className = 'dcb-sizechart-link';
          scl.textContent = 'Size chart';
          scl.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            openSizeChart(chart);
          });
          lrow.appendChild(scl);
          text.appendChild(lrow);
        })(pInfoC.size_chart);
      }
      var alloc = cardValue !== null ? cardValue
        : Math.round((parseFloat(c.alloc || '0') || 0) * 100);
      if (forcedOff) {
        var fo = document.createElement('span');
        fo.className = 'dcb-optional-soldout';
        fo.textContent = 'Sold out, not included right now';
        text.appendChild(fo);
      } else if (alloc > 0) {
        var pr = document.createElement('span');
        pr.className = 'dcb-optional-price';
        pr.textContent = includedNow ? ('included (+' + money(alloc) + ')')
                                     : ('+' + money(alloc));
        text.appendChild(pr);
      }
      // SOLD OUT prompt: the current overall selection is unavailable and
      // this slot has other options to pick
      if (!cur.available && includedNow && componentHasChoices(pos)) {
        var so = document.createElement('span');
        so.className = 'dcb-optional-soldout';
        so.textContent = 'Sold out — tap Options for an alternative';
        text.appendChild(so);
      }
      card.appendChild(text);
      if (componentHasChoices(pos)) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'dcb-optional-change';
        btn.textContent = 'Options';
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          openPopup(pos, c.title || '');
        });
        card.appendChild(btn);
        card.addEventListener('click', function (e) {
          if (e.target.tagName === 'INPUT') return;
          openPopup(pos, c.title || '');
        });
      }
      cardsWrap.appendChild(card);
    });
    writeSkipProperty();
    paintAdjustedPrice(cur);
    renderSelectionSpecs(cur, entry);
    syncProductTabs(cur, entry);
    // alt slots pick via the popup's product rows -- hide the includes
    // block's duplicate dropdown for those attrs (the hidden select is
    // still the mechanism the rows drive)
    // first paint complete: lift the boot veil (CSS failsafe lifts it at
    // 1.6s regardless, so a script failure can never hide the column)
    document.documentElement.classList.add('dcb-ready');
    try {
      // remember exact heights so the NEXT visit reserves them precisely
      var h1 = cardsWrap ? Math.round(cardsWrap.getBoundingClientRect().height) : 0;
      var h2 = specsWrap && specsWrap.isConnected ? Math.round(specsWrap.getBoundingClientRect().height) : 0;
      var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
      if (handle && h1 > 0 && h2 > 0) {
        localStorage.setItem('dcb_h_' + handle, JSON.stringify({ cards: h1, specs: h2 + 14 }));
      }
    } catch (e) { /* noop */ }
    // ALL selections live on the cards -- the grid's option rows above
    // the includes grid are redundant (Dany 2026-08-19 cleanup). The
    // hidden selects inside remain the programmatic channel.
    document.querySelectorAll('.dcb-pickers').forEach(function (pw) {
      if (pw.style.display !== 'none') pw.style.display = 'none';
    });
    patchAltProperties();
  }
  // ---- interactive per-selection specs (Dany 2026-08-18: specs follow
  // the customer's configuration; the server-rendered SEO tabs stay
  // anchored to the default config for Google) -----------------------
  var specsWrap = null;
  function placeSpecsPanel() {
    // Dany 2026-08-19: "Your configuration" lives in the left column above
    // the Qikify offer box. Qikify CREATES its mount ~2s after load inside
    // the product-details section, so the only jump-free strategy is to
    // put the panel at the TOP of that section immediately (it exists,
    // empty, from the first byte; its height is reserved by CSS) and let
    // Qikify append below. Never anchor on Qikify's early placeholder in
    // the recommendations section.
    if (!specsWrap) return false;
    var details = document.querySelector('[id$="__details"]');
    if (!details) {
      if (specsWrap.isConnected) return true;
      var media = document.getElementById('product-media') || document.querySelector('media-gallery');
      if (media && media.parentNode) { media.parentNode.insertBefore(specsWrap, media.nextSibling); return true; }
      return false;
    }
    var host = details.querySelector('.container') || details;
    var qbk = details.querySelector('.qbk-product-offer');
    if (qbk && qbk.parentNode && specsWrap.nextElementSibling !== qbk) {
      // Qikify mounted ABOVE us -- step in front of it once
      if (specsWrap.compareDocumentPosition(qbk) & Node.DOCUMENT_POSITION_PRECEDING) {
        qbk.parentNode.insertBefore(specsWrap, qbk);
      }
      return true;
    }
    if (specsWrap.parentNode !== host || host.firstElementChild !== specsWrap) {
      if (!specsWrap.isConnected || !host.contains(specsWrap)) host.insertBefore(specsWrap, host.firstChild);
    }
    return true;
  }
  function renderSelectionSpecs(cur, entry) {
    if (!entry || !entry.components) return;
    var rows = [];
    entry.components.forEach(function (c) {
      if (!c || !c.position) return;
      if (c.removable && window.__dcbSkipPos[c.position]) return; // removed
      var name = c.title, handle = c.handle, price = null;
      var ai = altInfo(c);
      if (ai && ai.chosen) {
        name = ai.chosen.title || ai.chosen.label;
        handle = ai.chosen.handle || handle;
        price = typeof ai.chosen.price === 'number' ? ai.chosen.price : null;
      }
      var info = productInfo(handle);
      rows.push({ name: name, handle: handle, price: price,
                  specs: (info && info.specs) || [], url: info && info.url });
    });
    if (!rows.length) return;
    if (!specsWrap || !specsWrap.isConnected) {
      specsWrap = document.createElement('div');
      specsWrap.className = 'dcb-config-specs';
      if (!placeSpecsPanel()) {
        if (cardsWrap && cardsWrap.parentNode) {
          cardsWrap.parentNode.insertBefore(specsWrap, cardsWrap.nextSibling);
        } else { return; }
      }
    } else placeSpecsPanel();
    specsWrap.innerHTML = '';
    var head = document.createElement('div');
    head.className = 'dcb-config-specs-head';
    head.textContent = 'Your configuration — key specs';
    specsWrap.appendChild(head);
    // customized = any alt choice off its default, any removal, or any
    // non-default variant selection
    var customized = Object.keys(window.__dcbSkipPos).some(function (k) {
      return window.__dcbSkipPos[k];
    });
    entry.components.forEach(function (c) {
      var ai = altInfo(c);
      if (ai && ai.chosen && ai.base && ai.chosen.label !== ai.base.label) {
        customized = true;
      }
    });
    if (customized) {
      var note = document.createElement('div');
      note.className = 'dcb-config-note';
      note.textContent = 'You\u2019ve customized this package. The '
        + 'description, features and specs tabs below describe the '
        + 'standard configuration \u2014 your selected items\u2019 exact '
        + 'details are shown here and on each item\u2019s own page.';
      specsWrap.appendChild(note);
    }
    rows.forEach(function (r) {
      var item = document.createElement('div');
      item.className = 'dcb-config-item';
      var nm = document.createElement('div');
      nm.className = 'dcb-config-name';
      nm.textContent = r.name + (r.price ? ' — ' + money(r.price) : '');
      if (r.url) {
        var lk = document.createElement('a');
        lk.className = 'dcb-config-link';
        lk.href = r.url;
        lk.target = '_blank';
        lk.rel = 'noopener';
        lk.textContent = 'Full details \u2197';
        nm.appendChild(lk);
      }
      item.appendChild(nm);
      if (r.specs.length) {
        var tbl = document.createElement('div');
        tbl.className = 'dcb-config-rows';
        r.specs.slice(0, 3).forEach(function (sp) {
          var row = document.createElement('div');
          row.className = 'dcb-config-row';
          if (sp && typeof sp === 'object' && sp.label) {
            var l = document.createElement('span');
            l.className = 'dcb-config-l';
            l.textContent = sp.label;
            row.appendChild(l);
            var v = document.createElement('span');
            v.className = 'dcb-config-v';
            v.textContent = sp.value || '-';
            row.appendChild(v);
          } else {
            var t = document.createElement('span');
            t.className = 'dcb-config-v';
            t.textContent = String(sp);
            row.appendChild(t);
          }
          tbl.appendChild(row);
        });
        item.appendChild(tbl);
      }
      specsWrap.appendChild(item);
    });
  }
  // ---- reactive Product Information tabs (Dany 2026-08-18: the tabs
  // themselves show data for the CHOSEN configuration; the server-rendered
  // default content stays below for SEO) ------------------------------
  function selectedRows(cur, entry) {
    var rows = [];
    entry.components.forEach(function (c) {
      if (!c || !c.position) return;
      if (c.removable && window.__dcbSkipPos[c.position]) return;
      var name = c.title, handle = c.handle, price = null;
      var ai = altInfo(c);
      if (ai && ai.chosen) {
        name = ai.chosen.title || ai.chosen.label;
        handle = ai.chosen.handle || handle;
        price = typeof ai.chosen.price === 'number' ? ai.chosen.price : null;
      } else if (c.alloc) {
        price = Math.round((parseFloat(c.alloc) || 0) * 100);
      }
      var info = productInfo(handle);
      rows.push({ name: name, handle: handle, price: price,
                  specs: (info && info.specs) || [],
                  url: (info && info.url) || c.url });
    });
    return rows;
  }
  function tabPanelByName(name) {
    var btns = document.querySelectorAll('.dc-ptabs__tab');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].textContent.trim().toLowerCase() === name.toLowerCase()) {
        var pid = btns[i].getAttribute('aria-controls');
        if (pid) return document.getElementById(pid);
      }
    }
    return null;
  }
  function liveRegion(panel) {
    var region = panel.querySelector(':scope > .dcb-tab-live');
    if (!region) {
      region = document.createElement('div');
      region.className = 'dcb-tab-live';
      panel.insertBefore(region, panel.firstChild);
    }
    return region;
  }
  function syncProductTabs(cur, entry) {
    if (!entry || !entry.components) return;
    var rows = selectedRows(cur, entry);
    if (!rows.length) return;
    var configLine = rows.map(function (r) { return r.name; }).join(' + ');
    var total = money(adjustedPriceCents(cur));
    // Specifications: per-component spec tables for the chosen config
    var specPanel = tabPanelByName('Specifications') || tabPanelByName('Specs');
    if (specPanel) {
      var reg = liveRegion(specPanel);
      reg.innerHTML = '';
      var h = document.createElement('div');
      h.className = 'dcb-tab-live-head';
      h.textContent = 'Specifications — your configuration';
      reg.appendChild(h);
      rows.forEach(function (r) {
        var item = document.createElement('div');
        item.className = 'dcb-config-item';
        var nm = document.createElement('div');
        nm.className = 'dcb-config-name';
        nm.textContent = r.name;
        if (r.url) {
          var lk = document.createElement('a');
          lk.className = 'dcb-config-link';
          lk.href = r.url;
          lk.target = '_blank';
          lk.rel = 'noopener';
          lk.textContent = 'Full specs \u2197';
          nm.appendChild(lk);
        }
        item.appendChild(nm);
        var tbl = document.createElement('div');
        tbl.className = 'dcb-config-rows';
        r.specs.slice(0, 3).forEach(function (sp) {
          var row = document.createElement('div');
          row.className = 'dcb-config-row';
          if (sp && typeof sp === 'object' && sp.label) {
            var l = document.createElement('span');
            l.className = 'dcb-config-l';
            l.textContent = sp.label;
            row.appendChild(l);
            var v = document.createElement('span');
            v.className = 'dcb-config-v';
            v.textContent = sp.value || '-';
            row.appendChild(v);
          } else {
            var t = document.createElement('span');
            t.className = 'dcb-config-v';
            t.textContent = String(sp);
            row.appendChild(t);
          }
          tbl.appendChild(row);
        });
        item.appendChild(tbl);
        reg.appendChild(item);
      });
      var dv = document.createElement('div');
      dv.className = 'dcb-tab-live-divider';
      dv.textContent = 'Standard package information';
      reg.appendChild(dv);
    }
    // What's Included: the chosen list with prices + links
    var incPanel = tabPanelByName("What's Included") || tabPanelByName('Included');
    if (incPanel) {
      var reg2 = liveRegion(incPanel);
      reg2.innerHTML = '';
      var h2 = document.createElement('div');
      h2.className = 'dcb-tab-live-head';
      h2.textContent = 'Your configuration (' + total + ')';
      reg2.appendChild(h2);
      var ul = document.createElement('ul');
      ul.className = 'dcb-tab-live-list';
      rows.forEach(function (r) {
        var li = document.createElement('li');
        li.textContent = r.name + (r.price ? ' — ' + money(r.price) : '');
        if (r.url) {
          var lk2 = document.createElement('a');
          lk2.className = 'dcb-config-link';
          lk2.href = r.url;
          lk2.target = '_blank';
          lk2.rel = 'noopener';
          lk2.textContent = 'details \u2197';
          li.appendChild(lk2);
        }
        ul.appendChild(li);
      });
      reg2.appendChild(ul);
      var dv2 = document.createElement('div');
      dv2.className = 'dcb-tab-live-divider';
      dv2.textContent = 'Standard package information';
      reg2.appendChild(dv2);
    }
    // Description + Features: live configuration line on top
    ['Description', 'Features'].forEach(function (nm2) {
      var panel = tabPanelByName(nm2);
      if (!panel) return;
      var reg3 = liveRegion(panel);
      reg3.innerHTML = '';
      var line = document.createElement('div');
      line.className = 'dcb-tab-live-config';
      line.textContent = 'Your configuration: ' + configLine + ' — ' + total;
      reg3.appendChild(line);
    });
  }
  // ---- upgrade popup --------------------------------------------------
  function productInfo(handle) {
    var im = includesMap();
    return (im && im.products && handle) ? im.products[handle] : null;
  }
  function buildCompareColumn(opts) {
    // one compare column as FIXED ROW SLOTS so a CSS subgrid can align
    // every row straight across the three cards (Dany 2026-08-19): the
    // slot count is identical for all columns of a ladder --
    // image, name, price, bundle total, delta, blurb, N spec rows,
    // M control rows, size row, sold-out row, actions.
    var col = document.createElement('div');
    col.className = 'dcb-cmp-col' + (opts.current ? ' is-current' : '')
      + (opts.soldout ? ' is-soldout' : '');
    var info = productInfo(opts.handle);
    function slot(cls, fill) {
      var d = document.createElement('div');
      d.className = cls;
      if (fill) fill(d);
      col.appendChild(d);
      return d;
    }
    var im2 = null;
    slot('dcb-cmp-imgbox', function (d) {
      if (opts.image) {
        im2 = document.createElement('img');
        im2.className = 'dcb-cmp-img';
        im2.src = opts.image;
        im2.alt = opts.name;
        d.appendChild(im2);
      }
    });
    slot('dcb-cmp-name', function (d) { d.textContent = opts.name; d.title = opts.name; });
    var skuSlot = slot('dcb-cmp-sku' + (opts.sku ? '' : ' is-empty'), function (d) {
      d.textContent = opts.sku ? 'SKU ' + opts.sku : ' ';
    });
    function showSku(v) {
      if (!v || !skuSlot) return;
      skuSlot.textContent = 'SKU ' + v;
      skuSlot.classList.remove('is-empty');
    }
    slot('dcb-cmp-value', function (d) {
      d.textContent = (typeof opts.value === 'number' && opts.value > 0) ? money(opts.value) : ' ';
    });
    slot('dcb-cmp-bundle', function (d) {
      d.textContent = typeof opts.bundleTotal === 'number'
        ? 'Bundle total ' + money(opts.bundleTotal) : ' ';
    });
    slot('dcb-cmp-delta', function (d) {
      // no price deltas here (Dany 2026-08-19): the option's own price is
      // already shown; the row only marks the current pick
      d.textContent = opts.current ? 'Current selection' : ' ';
    });
    slot('dcb-cmp-blurb', function (d) {
      d.textContent = (info && info.blurb) ? info.blurb : ' ';
    });
    var specs = (info && info.specs) || [];
    var nSpec = typeof opts.specRows === 'number' ? opts.specRows : specs.length;
    for (var si = 0; si < nSpec; si++) {
      (function (sp) {
        slot('dcb-cmp-spec' + (sp ? '' : ' is-empty'), function (d) {
          var lb = document.createElement('span');
          lb.className = 'dcb-cmp-spec-l';
          var vv = document.createElement('span');
          vv.className = 'dcb-cmp-spec-v';
          if (sp && typeof sp === 'object' && sp.label) {
            lb.textContent = sp.label;
            var val = (sp.value || '').trim();
            if (!val || val === '-' || val === '—') {
              vv.textContent = '—';
              vv.classList.add('is-na');
            } else vv.textContent = val;
          } else if (sp) {
            lb.textContent = '';
            vv.textContent = String(sp);
          } else {
            lb.textContent = ' ';
            vv.textContent = ' ';
          }
          d.appendChild(lb);
          d.appendChild(vv);
        });
      })(specs[si]);
    }
    // control rows (colors / pickers), padded to the ladder maximum
    var dds = opts.dropdowns || [];
    var nCtrl = typeof opts.ctrlRows === 'number' ? opts.ctrlRows : dds.length;
    for (var ci = 0; ci < nCtrl; ci++) {
      (function (dd) {
        slot('dcb-cmp-color' + (dd ? '' : ' is-empty'), function (d) {
          if (!dd || !Array.isArray(dd.options) || dd.options.length < 2) {
            d.innerHTML = '&nbsp;';
            return;
          }
          d.addEventListener('click', function (e) { e.stopPropagation(); });
          var cs = document.createElement('span');
          cs.className = 'dcb-cmp-ctl-label';
          cs.textContent = dd.label || 'Color';
          d.appendChild(cs);
          var csel = document.createElement('select');
          dd.options.forEach(function (o) {
            var op = document.createElement('option');
            op.value = o.label; op.textContent = o.label;
            csel.appendChild(op);
          });
          if (dd.value) csel.value = dd.value;
          csel.addEventListener('change', function () {
            var o = null;
            for (var q = 0; q < dd.options.length; q++) {
              if (dd.options[q].label === csel.value) { o = dd.options[q]; break; }
            }
            if (o && o.image && im2) im2.src = o.image;
            if (o && o.sku) showSku(o.sku);
            if (dd.onChange) dd.onChange(csel.value);
          });
          d.appendChild(csel);
        });
      })(dds[ci]);
    }
    // size row: label + inline size chart link, full-width select
    slot('dcb-cmp-color dcb-cmp-size' + (opts.sizeSel || (info && info.size_chart) ? '' : ' is-empty'), function (d) {
      d.addEventListener('click', function (e) { e.stopPropagation(); });
      var head = document.createElement('span');
      head.className = 'dcb-cmp-ctl-label';
      head.textContent = opts.sizeSel ? (opts.sizeSel.label || 'Size') : '';
      if (info && info.size_chart) {
        (function (chart) {
          var scl = document.createElement('a');
          scl.href = '#';
          scl.className = 'dcb-sizechart-link';
          scl.textContent = 'Size chart';
          scl.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            openSizeChart(chart);
          });
          head.appendChild(scl);
        })(info.size_chart);
      }
      d.appendChild(head);
      if (opts.sizeSel && Array.isArray(opts.sizeSel.options) && opts.sizeSel.options.length > 1) {
        var ssel = document.createElement('select');
        opts.sizeSel.options.forEach(function (o) {
          var op = document.createElement('option');
          op.value = o.value; op.textContent = o.text;
          ssel.appendChild(op);
        });
        if (opts.sizeSel.value) ssel.value = opts.sizeSel.value;
        ssel.addEventListener('change', function () {
          if (opts.sizeSel.skuFor) showSku(opts.sizeSel.skuFor(ssel.value));
          if (opts.sizeSel.onChange) opts.sizeSel.onChange(ssel.value);
        });
        d.appendChild(ssel);
      } else if (!(info && info.size_chart)) {
        head.innerHTML = '&nbsp;';
      }
    });
    slot('dcb-cmp-soldout' + (opts.soldout ? '' : ' is-empty'), function (d) {
      d.textContent = opts.soldout ? 'SOLD OUT' : ' ';
    });
    slot('dcb-cmp-actions', function (d) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dcb-cmp-select';
      btn.textContent = opts.current ? 'Selected' : 'Select';
      btn.disabled = !!opts.current;
      if (!opts.current) btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled) return;
        btn.disabled = true;
        btn.textContent = 'Applying…';
        opts.onSelect();
      });
      d.appendChild(btn);
      var url = (info && info.url) || opts.url;
      if (url) {
        var lm = document.createElement('a');
        lm.className = 'dcb-cmp-learn';
        lm.href = url;
        lm.target = '_blank';
        lm.rel = 'noopener';
        lm.textContent = 'Learn more ↗';
        lm.addEventListener('click', function (e) { e.stopPropagation(); });
        d.appendChild(lm);
      }
    });
    return col;
  }
  function equalizeRows(grid) {
    // browser-independent row alignment (Dany 2026-08-19: rows must line
    // up straight across the cards): measure slot r in every card and pin
    // all of them to the tallest. Subgrid does this natively where
    // supported; this guarantees it everywhere else too.
    var cols = Array.prototype.filter.call(grid.children, function (c) {
      return c.classList && c.classList.contains('dcb-cmp-col');
    });
    if (cols.length < 2) return;
    cols.forEach(function (c) {
      Array.prototype.forEach.call(c.children, function (ch) { ch.style.minHeight = ''; });
    });
    if (window.innerWidth <= 640) return; // stacked on mobile
    var n = Math.min.apply(null, cols.map(function (c) { return c.children.length; }));
    for (var r = 0; r < n; r++) {
      var h = 0;
      cols.forEach(function (c) {
        h = Math.max(h, c.children[r].getBoundingClientRect().height);
      });
      cols.forEach(function (c) { c.children[r].style.minHeight = Math.ceil(h) + 'px'; });
    }
  }
  function equalizeAllGrids() {
    document.querySelectorAll('.dcb-popup .dcb-cmp-grid').forEach(equalizeRows);
  }
  window.addEventListener('resize', function () { window.setTimeout(equalizeAllGrids, 50); });
  function layoutCompareGrid(grid, colOpts) {
    // equalize slot counts across the ladder, build, and size the subgrid
    var specRows = 0, ctrlRows = 0;
    colOpts.forEach(function (o) {
      var inf = productInfo(o.handle);
      specRows = Math.max(specRows, ((inf && inf.specs) || []).length);
      ctrlRows = Math.max(ctrlRows, (o.dropdowns || []).length);
    });
    var rows = 10 + specRows + ctrlRows;
    grid.style.gridTemplateRows = 'repeat(' + rows + ', auto)';
    colOpts.forEach(function (o) {
      o.specRows = specRows;
      o.ctrlRows = ctrlRows;
      var col = buildCompareColumn(o);
      col.style.gridRow = 'span ' + rows;
      grid.appendChild(col);
    });
  }
  var popupEl = null;
  function openSizeChart(chart) {
    // clean restyled table popup; html was reduced to bare <table> blocks
    // from OUR OWN size-chart pages at publish (custom.size_chart)
    closePopup();
    popupEl = document.createElement('div');
    popupEl.className = 'dcb-popup-backdrop';
    popupEl.addEventListener('click', function (e) {
      if (e.target === popupEl) closePopup();
    });
    var box = document.createElement('div');
    box.className = 'dcb-popup dcb-sizechart';
    var head = document.createElement('div');
    head.className = 'dcb-popup-head';
    var ht = document.createElement('span');
    ht.textContent = chart.title || 'Size chart';
    head.appendChild(ht);
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'dcb-popup-close';
    x.textContent = '\u2715';
    x.addEventListener('click', closePopup);
    head.appendChild(x);
    box.appendChild(head);
    var body = document.createElement('div');
    body.className = 'dcb-sizechart-body';
    body.innerHTML = chart.html;
    box.appendChild(body);
    popupEl.appendChild(box);
    document.body.appendChild(popupEl);
  }
  function closePopup() {
    if (popupEl && popupEl.parentNode) popupEl.parentNode.removeChild(popupEl);
    popupEl = null;
  }
  function openPopup(pos, title) {
    closePopup();
    var cur = currentVariant();
    if (!cur) return;
    var dm = dimMap();
    popupEl = document.createElement('div');
    popupEl.className = 'dcb-popup-backdrop';
    popupEl.addEventListener('click', function (e) {
      if (e.target === popupEl) closePopup();
    });
    var box = document.createElement('div');
    box.className = 'dcb-popup';
    var head = document.createElement('div');
    head.className = 'dcb-popup-head';
    var ht = document.createElement('span');
    ht.textContent = 'Choose your ' + (optNames[Object.keys(dm.product).find(
      function (k) { return dm.product[k] === pos; })] || title || 'option');
    head.appendChild(ht);
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'dcb-popup-close';
    x.textContent = '✕';
    x.addEventListener('click', closePopup);
    head.appendChild(x);
    box.appendChild(head);
    // 0. options v3.5 alt ladder for this slot (slot-free product swap)
    var entryNow = entryFor(cur.id);
    var altComp = entryNow && entryNow.components
      ? entryNow.components.find(function (c) {
          return c && c.position === pos && isAltComp(c);
        }) : null;
    if (altComp) {
      var ai2 = altInfo(altComp);
      var adjNow = adjustedPriceCents(cur);
      var names3a = altComp.choices.length === 2 ? ['Good', 'Best']
        : ['Good', 'Better', 'Best'];
      var rankedA = altComp.choices.slice().sort(function (a, b) {
        return (a.price || 0) - (b.price || 0);
      });
      // always MAX 3 columns (screen alignment): keep the current choice
      // and fill with cheapest-first tiers
      if (rankedA.length > 3) {
        var curLabel = ai2 && ai2.chosen ? ai2.chosen.label : null;
        var kept = rankedA.filter(function (ch) { return ch.label === curLabel; });
        // fill from the TOP tiers down -- the cap must never hide the
        // premium upsell options
        rankedA.slice().reverse().forEach(function (ch) {
          if (kept.length < 3 && kept.indexOf(ch) === -1) kept.push(ch);
        });
        rankedA = kept.sort(function (a, b) { return (a.price || 0) - (b.price || 0); });
      }
      var badgeA = {};
      rankedA.forEach(function (ch, k) {
        badgeA[ch.label] = names3a[Math.min(k, names3a.length - 1)];
      });
      var gridA = document.createElement('div');
      gridA.className = 'dcb-cmp-grid';
      var colOptsA = [];
      rankedA.forEach(function (ch) {
        var isCur = !!(ai2 && ai2.chosen && ai2.chosen.label === ch.label);
        var newTotalA = null, deltaA = 0;
        if (ai2 && ai2.chosen && typeof ch.price === 'number'
            && typeof ai2.chosen.price === 'number') {
          newTotalA = adjNow + (ch.price - ai2.chosen.price);
          deltaA = newTotalA - adjNow;
        }
        // v3.6: this choice's own color dropdown (colors are same-price
        // in-stock variants baked at publish; sold-out colors never bake)
        var dropdowns = [];
        var colImage = ch.image;
        var colSku = ch.sku || null;
        if (Array.isArray(ch.variants) && ch.variants.length > 1) {
          var memoC = (window.__dcbAltColor[altComp.attr] || {})[ch.label];
          var defC = null, curC = null;
          for (var q2 = 0; q2 < ch.variants.length; q2++) {
            var vr = ch.variants[q2];
            if (vr && vr['default'] && !defC) defC = vr;
            if (vr && memoC && vr.label === memoC) curC = vr;
          }
          defC = defC || ch.variants[0];
          curC = curC || defC;
          if (curC.image) colImage = curC.image;
          if (curC.sku) colSku = curC.sku;
          dropdowns.push({
            label: ch.opt_label || 'Color',
            options: ch.variants,
            value: curC.label,
            onChange: function (val) {
              (window.__dcbAltColor[altComp.attr] = window.__dcbAltColor[altComp.attr] || {})[ch.label] = val;
              if (isCur) {
                applyAltColorByPos(pos);
                renderCards();
              }
            }
          });
        }
        colOptsA.push({
          image: colImage,
          sku: colSku,
          name: ch.title || ch.label,
          value: typeof ch.price === 'number' ? ch.price : null,
          bundleTotal: newTotalA,
          delta: deltaA,
          current: isCur,
          soldout: false,
          handle: ch.handle,
          dropdowns: dropdowns,
          onSelect: function () {
            var live = document.getElementById('dcb-pick-' + altComp.attr);
            if (live) {
              live.value = ch.label;
              live.dispatchEvent(new Event('change', { bubbles: true }));
            }
            window.setTimeout(function () {
              // self-check: if the includes select re-rendered under us,
              // set it again (the old one-shot was part of the "press
              // Select twice" bug)
              var live2 = document.getElementById('dcb-pick-' + altComp.attr);
              if (live2 && live2.value !== ch.label) {
                live2.value = ch.label;
                live2.dispatchEvent(new Event('change', { bubbles: true }));
              }
              applyAltColorByPos(pos);
              var c2 = currentVariant();
              if (c2) paintAdjustedPrice(c2);
              renderCards();
              openPopup(pos, title);
            }, 400);
          }
        });
      });
      layoutCompareGrid(gridA, colOptsA);
      box.appendChild(gridA);
    }
    var pickersInColumn = false;
    var sizeInColumn = {};
    // 1. product choices — good / better / best, price-ranked badges,
    // image + price on EVERY row (fallback to any variant carrying the
    // value when the exact combo is missing)
    for (var i = 0; i < optNames.length; i++) {
      if (dm.product[i] !== pos) continue;
      var vals = dimValues(i);
      var rowsData = vals.map(function (val) {
        var target = variantWith(cur, i, val);
        var fallback = target || variants.find(function (v) {
          return v.options[i] === val;
        }) || null;
        // the row's picture and PRICE come from the component PRODUCT
        // itself (via the includes map), never the bundle composite
        var prodImg = null, prodValue = null;
        if (fallback) {
          var fe = entryFor(fallback.id);
          if (fe && fe.components) {
            var fc = fe.components.find(function (c) {
              return c && c.position === pos;
            });
            if (fc) {
              if (fc.image) prodImg = fc.image;
              if (typeof fc.price === 'number') prodValue = fc.price;
            }
          }
        }
        return { val: val, target: target, ref: fallback,
                 img: prodImg, value: prodValue };
      });
      // Self-healing rotation (Dany 2026-08-18): sold-out choices are NOT
      // shown -- the next in-stock choice rotates in. The current
      // selection's row always shows (marked SOLD OUT when dead) so the
      // shopper understands their state. Up to 3 rows.
      rowsData = rowsData.filter(function (r) {
        if (cur.options[i] === r.val) return true; // current: always
        return r.target && r.target.available;
      });
      if (rowsData.length > 3) {
        var keep = rowsData.filter(function (r) { return cur.options[i] === r.val; });
        // fill from the TOP tiers down, same policy as alt ladders -- the
        // cap must never hide the premium upsell (T3 on the Atomic reg
        // ladder, Dany 2026-08-19)
        rowsData.slice().sort(function (a, b) {
          return (b.value || 0) - (a.value || 0);
        }).forEach(function (r) {
          if (keep.length < 3 && keep.indexOf(r) === -1) keep.push(r);
        });
        rowsData = keep;
      }
      // Good/Better/Best is EARNED by the product's own price (Dany
      // 2026-08-18: tiers reflect price range, not curation order);
      // ladder order is only the fallback when values are missing
      var badgeByVal = {};
      if (rowsData.length >= 2) {
        var names3 = rowsData.length === 2 ? ['Good', 'Best']
          : ['Good', 'Better', 'Best'];
        var ranked = rowsData.slice();
        if (ranked.every(function (r) { return typeof r.value === 'number'; })) {
          ranked.sort(function (a, b) { return a.value - b.value; });
        }
        ranked.forEach(function (r, k) {
          badgeByVal[r.val] = names3[Math.min(k, names3.length - 1)];
        });
      }
      // display order: by value ascending so tiers read Good -> Best
      rowsData.sort(function (a, b) {
        return (a.value || 0) - (b.value || 0);
      });
      var gridV = document.createElement('div');
      gridV.className = 'dcb-cmp-grid';
      var colOptsV = [];
      rowsData.forEach(function (rd) {
        var val = rd.val, target = rd.target, ref = rd.ref;
        var soldout = (!target || !target.available);
        var newTotalV = ref ? ref.price : null;
        var deltaV = ref ? (ref.price - cur.price) : 0;
        // find the component's handle in the target combo for specs/url
        var chandle = null, colSkuV = null;
        var fe2 = ref ? entryFor(ref.id) : null;
        if (fe2 && fe2.components) {
          var fc2 = fe2.components.find(function (c) {
            return c && c.position === pos;
          });
          if (fc2 && fc2.handle) chandle = fc2.handle;
          if (fc2 && fc2.sku) colSkuV = fc2.sku;
        }
        // sku of this slot in the combo (product val, size sz, rest as now)
        function skuInCombo(pi, pval, sjj, sz) {
          var t = variants.find(function (v) {
            return v.options.every(function (o, k) {
              if (k === pi) return o === pval;
              if (k === sjj) return o === sz;
              return o === cur.options[k];
            });
          });
          var te = t ? entryFor(t.id) : null;
          var tc = te && te.components ? te.components.find(function (c) {
            return c && c.position === pos;
          }) : null;
          return tc && tc.sku ? tc.sku : '';
        }
        var isCurCol = cur.options[i] === val;
        // this slot's size dim rendered INSIDE the column (every column,
        // not just the current one); pending picks apply with Select
        var sizeSel = null, sizeDimIdx = null;
        for (var sj = 0; sj < optNames.length; sj++) {
          if (dm.attr[sj] !== pos) continue;
          var svals = dimValues(sj);
          if (svals.length < 2 || svals.indexOf('Included') !== -1) continue;
          sizeDimIdx = sj;
          sizeInColumn[sj] = true;
          (function (sjj, sv, pi, pval, curCol) {
            var memoKey = pos + '|' + pval + '|size';
            var pendS = (window.__dcbSwapSize || {})[memoKey];
            if (!curCol && pendS) colSkuV = skuInCombo(pi, pval, sjj, pendS) || colSkuV;
            sizeSel = {
              label: optNames[sjj],
              options: sv.map(function (sz) {
                var t = variants.find(function (v) {
                  return v.options.every(function (o, k) {
                    if (k === pi) return o === pval;
                    if (k === sjj) return o === sz;
                    return o === cur.options[k];
                  });
                });
                return { value: sz,
                         text: sz + (t && !t.available ? ' \u2014 sold out' : '') };
              }),
              value: curCol ? cur.options[sjj] : (pendS || cur.options[sjj]),
              skuFor: function (sz) { return skuInCombo(pi, pval, sjj, sz); },
              onChange: function (v4) {
                if (curCol) {
                  applyWalk(sjj, v4, function () {
                    renderCards();
                    openPopup(pos, title);
                  });
                } else {
                  (window.__dcbSwapSize = window.__dcbSwapSize || {})[memoKey] = v4;
                }
              }
            };
          })(sj, svals, i, val, isCurCol);
          break;
        }
        // EVERY column with color variations carries a dropdown under the
        // product name (Dany 2026-08-18: "every single option product,
        // good better or best"). The current column drives the live
        // picker -- and its image STICKS to the picked color across popup
        // rebuilds; other columns hold a pending pick (menu baked into
        // products[handle].colors by the same generator as the live
        // picker) that applies with Select.
        var dropdowns = [];
        var colImgOverride = null;
        if (!isCurCol && chandle) {
          var pinf = productInfo(chandle);
          if (pinf && Array.isArray(pinf.colors) && pinf.colors.length > 1) {
            var pendKey = pos + '|' + chandle;
            var pend = (window.__dcbSwapColor || {})[pendKey];
            var defsw = null, curSw = null;
            for (var q4 = 0; q4 < pinf.colors.length; q4++) {
              var o4 = pinf.colors[q4];
              if (o4 && o4['default'] && !defsw) defsw = o4;
              if (o4 && pend && o4.label === pend) curSw = o4;
            }
            defsw = defsw || pinf.colors[0];
            curSw = curSw || defsw;
            if (curSw.image) colImgOverride = curSw.image;
            if (curSw.sku) colSkuV = curSw.sku;
            dropdowns.push({
              label: pinf.opt_label || 'Color',
              options: pinf.colors,
              value: curSw.label,
              onChange: (function (key) { return function (v3) {
                (window.__dcbSwapColor = window.__dcbSwapColor || {})[key] = v3;
              }; })(pendKey)
            });
          }
        }
        if (isCurCol) {
          pickersFor(pos).forEach(function (pk) {
            var lv = currentPickerValue(pk.attr);
            if (lv) {
              // rebuilds must not revert the image to the map default
              // (Dany 2026-08-18: pink mask flipped back to black)
              for (var q5 = 0; q5 < pk.choices.length; q5++) {
                if (pk.choices[q5].label === lv) {
                  if (pk.choices[q5].image) colImgOverride = pk.choices[q5].image;
                  if (pk.choices[q5].sku) colSkuV = pk.choices[q5].sku;
                  break;
                }
              }
            }
            dropdowns.push({
              label: pk.label,
              options: pk.choices,
              value: lv,
              onChange: function (v2) {
                var live = document.getElementById('dcb-pick-' + pk.attr);
                if (live) {
                  live.value = v2;
                  live.dispatchEvent(new Event('change', { bubbles: true }));
                }
                window.setTimeout(function () {
                  renderCards();
                  openPopup(pos, title);
                }, 350);
              }
            });
          });
          if (dropdowns.length) pickersInColumn = true;
        }
        colOptsV.push({
          // component product photo ONLY -- the variant image is the
          // bundle composite and must never appear as a product image
          image: colImgOverride || rd.img || null,
          sku: colSkuV,
          name: val,
          value: (typeof rd.value === 'number' && rd.value > 0) ? rd.value : null,
          bundleTotal: newTotalV,
          delta: deltaV,
          current: isCurCol,
          soldout: soldout,
          handle: chandle,
          dropdowns: dropdowns,
          sizeSel: sizeSel,
          onSelect: (function (dimI, sizeDim) { return function () {
            // product first, then the pending size, then the pending
            // color -- each apply-and-verified (one press, always lands)
            applyWalk(dimI, val, function () {
              var pendSize = sizeDim !== null
                ? (window.__dcbSwapSize || {})[pos + '|' + val + '|size'] : null;
              var afterSize = function () {
                var pend2 = chandle ? (window.__dcbSwapColor || {})[pos + '|' + chandle] : null;
                window.setTimeout(function () {
                  if (pend2) {
                    pickersFor(pos).forEach(function (pk) {
                      var live = document.getElementById('dcb-pick-' + pk.attr);
                      if (live && Array.prototype.some.call(live.options,
                          function (o) { return o.value === pend2; })) {
                        live.value = pend2;
                        live.dispatchEvent(new Event('change', { bubbles: true }));
                      }
                    });
                  }
                  renderCards();
                  openPopup(pos, title); // refresh in place with new selection
                }, pend2 ? 350 : 0);
              };
              if (pendSize) applyWalk(sizeDim, pendSize, afterSize);
              else afterSize();
            });
          }; })(i, sizeDimIdx)
        });
      });
      layoutCompareGrid(gridV, colOptsV);
      box.appendChild(gridV);
    }
    // 2. attribute dims for this slot (size / color that are variant dims)
    for (var j = 0; j < optNames.length; j++) {
      if (dm.attr[j] !== pos) continue;
      if (sizeInColumn[j]) continue; // rendered inside the ladder columns
      var vals = dimValues(j);
      if (vals.length < 2 || vals.indexOf('Included') !== -1) continue;
      (function (jj, vv) {
        var wrap = document.createElement('label');
        wrap.className = 'dcb-popup-dim';
        var sp = document.createElement('span');
        sp.textContent = optNames[jj] + ':';
        wrap.appendChild(sp);
        var sel = document.createElement('select');
        vv.forEach(function (val) {
          var o = document.createElement('option');
          o.value = val;
          var t = variantWith(cur, jj, val);
          o.textContent = val + (t && !t.available ? ' — sold out' : '');
          sel.appendChild(o);
        });
        sel.value = cur.options[jj];
        sel.addEventListener('change', function () {
          applyOption(sel.value);
          window.setTimeout(function () {
            renderCards();
            openPopup(pos, title); // images/prices refresh with selection
          }, 650);
        });
        wrap.appendChild(sel);
        box.appendChild(wrap);
      })(j, vals);
    }
    // 3. same-price pickers (options v2) -- only when there is no
    // product ladder for this slot (with a ladder, the pickers render
    // inside the selected column under the product name)
    if (!pickersInColumn) pickersFor(pos).forEach(function (pk) {
      var wrap = document.createElement('label');
      wrap.className = 'dcb-popup-dim';
      var sp = document.createElement('span');
      sp.textContent = pk.label + ':';
      wrap.appendChild(sp);
      var sel = document.createElement('select');
      pk.choices.forEach(function (ch) {
        var o = document.createElement('option');
        o.value = ch.label;
        o.textContent = ch.label;
        sel.appendChild(o);
      });
      var liveVal = currentPickerValue(pk.attr);
      if (liveVal) sel.value = liveVal;
      sel.addEventListener('change', function () {
        var live = document.getElementById('dcb-pick-' + pk.attr);
        if (live) {
          live.value = sel.value;
          live.dispatchEvent(new Event('change', { bubbles: true }));
        }
        window.setTimeout(function () {
          renderCards();
          openPopup(pos, title);
        }, 350);
      });
      wrap.appendChild(sel);
      box.appendChild(wrap);
    });
    popupEl.appendChild(box);
    document.body.appendChild(popupEl);
    // align rows now, again after images/fonts settle
    equalizeAllGrids();
    window.setTimeout(equalizeAllGrids, 150);
    window.setTimeout(equalizeAllGrids, 600);
  }
  // ---- sync -----------------------------------------------------------
  function check() {
    try {
      hideNativePicker();
      stripDecoLabels();
      renderCards();
    } catch (e) { /* fail soft */ }
  }
  document.addEventListener('on:variant:change', function () { window.setTimeout(check, 80); });
  document.addEventListener('change', function (e) {
    try {
      var t = e && e.target;
      if (!t || typeof t.closest !== 'function') return;
      if (t.closest('.dcb-optional-wrap') || t.closest('.dcb-popup')) return;
      var f = t.closest('form');
      if (!f || (f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      window.setTimeout(check, 80);
      window.setTimeout(check, 400);
    } catch (err) { /* noop */ }
  }, true);
  window.addEventListener('popstate', function () { window.setTimeout(check, 80); });
  function stripDecoLabels() {
    // Deco Product Labels injects a duplicate, animated image copy
    // (div.pl-container) into gallery items -- fully remove it on bundle
    // PDPs (Dany 2026-08-18), but never blind an item: only when the item
    // still has its own image outside the pl wrapper.
    document.querySelectorAll('.media-viewer__item .pl-container').forEach(function (pl) {
      var item = pl.closest('.media-viewer__item');
      if (!item) return;
      var ownImg = Array.from(item.querySelectorAll('img')).some(function (im) {
        return !pl.contains(im);
      });
      if (ownImg) pl.remove();
      else {
        pl.style.animation = 'none';
        pl.querySelectorAll('*').forEach(function (n) {
          n.style.animation = 'none';
          n.style.transition = 'none';
        });
      }
    });
  }
  if (!window.__dcbCardReassert) {
    window.__dcbCardReassert = setInterval(function () {
      try {
        hideNativePicker();
        stripDecoLabels();
        var c = currentVariant();
        if (c && skipListValue()) paintAdjustedPrice(c);
        patchAltProperties();
        placeSpecsPanel();
      } catch (e) { /* noop */ }
    }, 1000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else { check(); }
  window.setTimeout(check, 1200);
})();
